const months = [
  {
    label: "Baisakh",
    value: 1,
  },
  {
    label: "Jestha",
    value: 2,
  },
  {
    label: "Asadh",
    value: 3,
  },
  {
    label: "Shrawan",
    value: 4,
  },
  {
    label: "Bhadra",
    value: 5,
  },
  {
    label: "Ashwin",
    value: 6,
  },
  {
    label: "Kartik",
    value: 7,
  },
  {
    label: "Mangsir",
    value: 8,
  },
  {
    label: "Poush",
    value: 9,
  },
  {
    label: "Magh",
    value: 10,
  },
  {
    label: "Falgun",
    value: 11,
  },
  {
    label: "Chaitra",
    value: 12,
  },
];

export default months;
